import "solid-devtools";
const versionlabel = document.getElementById("beta-version-label")!;
declare const COMMIT_HASH: string;

versionlabel.innerText = `v2.19.1 beta build ${COMMIT_HASH.slice(0, 7)}`;
versionlabel.setAttribute("tip", COMMIT_HASH);
versionlabel.setAttribute("tipPosition", "up");

import { fetchItemBundle, items, onload } from "~/data/items";

fetchItemBundle("v19");
export const global = { noSpoilers: false };

import { lzwEncode } from "~/js/encode";
import { game } from "~/js/game";

import "~/js/casino";
import { getItem, itemQualities } from "~/js/items";
import { generateConvlr } from "~/js/itemsn";
import { createNotification } from "~/js/notifications";
import "~/js/online/coinflip";
import "~/js/online/profile";

import { Pages } from "~/js/pages";
import { getCurrency } from "~/js/prefs";
import select from "~/js/select";
import "~/js/sessions";

import { addStat } from "~/js/stats";
import "~/js/tips";
import "~/js/welcome";
import "~/js/inventory";
import "~/js/inspectItem";
import "~/js/crash";
import "~/js/mines";
import "~/pages/roulette/roulette";
import "~/js/click";
import "~/js/shooter";
import "~/js/inventory";
import "~/js/coinflip";

import { createEffect, createRoot } from "solid-js";
import { render } from "solid-js/web";
import { log } from "~/js/helper/weirdcaselogger";
import { isMasterItem } from "~/js/utils";
import type { PageId, PagePath } from "~/types";
import { loadSave, user } from "~/userStore";

if (!localStorage.flags) localStorage.flags = "";

void onload().then(async () => {
	console.log("Data loaded, initializing game...");
	await Promise.all([
		import("~/js/slots"),
		import("~/js/online/jackpot"),
		import("~/js/jackpot"),
		import("~/pages/upgrades/upgrades"),
		import("~/pages/achievements/achievements"),
		import("~/js/shop"),
		import("~/js/settings"),

		import("~/pages/spin/spin"),
		import("~/js/missions"),
		import("~/js/collection"),
		import("~/js/tradeup"),
		import("~/js/prestige"),
	]);
	generateConvlr();

	const url = new URL(window.location.href);

	if (url.pathname.length > 1) {
		const pageId = url.pathname.slice(1).toLowerCase() as PageId;
		const pageData = url.search.length > 0 ? decodeURIComponent(url.search.slice(1)) : "";
		showPage(pageData ? `${pageId}$${pageData}` : pageId);
	} else if (window.innerWidth < 500) showPage("inventory");
	else showPage("welcome");
	game.emit("update");
	game.emit("items-loaded");
	setTimeout(() => game.emit("update"), 100);
	document.body.classList.add("data-loaded");
	console.log("%cCC2 v2.19 ready", "color:lime;");
	for (let e = user.inventory.length - 1; e >= 0; e--) {
		const itemName = user.inventory[e];
		if (itemName === null) {
			// idk where null items come from but remove them ig
			user.inventory.splice(e, 1);
			continue;
		}
		if (itemName === undefined) {
			log("Undefined item in inventory, how???", { index: e, inventory: user.inventory });
			continue;
		}
		const item = getItem(itemName);
		if (isMasterItem(item)) {
			// remove master items from inventory and give equivalent normal item
			log("Removed master item from inventory", { item, index: e });
			user.inventory.splice(e, 1);
			if (item.qualities) user.inventory.push(`${item.short} (${itemQualities[item.qualities[0]!]})`);
		} else if (!items[itemName]) {
			let baseItem = itemName
				.replace("(Factory New)", "")
				.replace("(Minimal Wear)", "")
				.replace("(Field-Tested)", "")
				.replace("(Well-Worn)", "")
				.replace("(Battle-Scarred)", "")
				.trim();
			const wasStatTrak = baseItem.startsWith("StatTrak");
			const wasSouvenir = baseItem.startsWith("Souvenir");
			baseItem = baseItem.replace("Souvenir", "").replace("StatTrak", "").trim();
			if (items[baseItem]) {
				const newBaseItem = getItem(baseItem);
				if (!isMasterItem(newBaseItem)) {
					log("weide????", { newItem: newBaseItem, itemName, baseItem, index: e });
					continue;
				}

				let newItem = `${newBaseItem.short} (${newBaseItem.qualities === null ? "Vanilla" : itemQualities[newBaseItem.qualities[0]!]})`;
				if (wasStatTrak && newBaseItem.stattrakAvailable) newItem = `StatTrak ${newItem}`;
				if (wasSouvenir && newBaseItem.souvenirAvailable) newItem = `Souvenir ${newItem}`;
				user.inventory.splice(e, 1);
				user.inventory.push(newItem);
			} else console.log("ITEM DOESN'T EXIST ANYMORE", itemName, baseItem);
		}
	}
});

if (window.location.hostname === "localhost") {
	document.body.classList.add("dev");
	document.title = "(Development) Case Clicker 2 - Ozen";
	window.user = () => user;
}

const pageHistory: (PagePath | null)[] = [];

export function showPage(pagePath: PagePath, hideFromHistory = false, isTempPage = false, noUpdate = false, refresh = false) {
	document.body.focus();
	const pageId = pagePath.split("$")[0] as PageId;

	const pageData = pagePath.split("$")[1];

	if (pageHistory.at(-1) === null) pageHistory.pop();
	if (!hideFromHistory) pageHistory.push(pagePath);
	else if (!isTempPage) pageHistory.push(null); // if hidden and not temp, add null to know when to go back ???

	if (!noUpdate) game.emit("update", true);

	const pages = document.querySelectorAll("[page]");
	pages.forEach((e) => {
		e.classList.remove("show");
	});

	const navBtns = document.querySelectorAll("[nbtn]");
	navBtns.forEach((e) => {
		e.classList.remove("active");
		if (e.getAttribute("nbtn") === pageId) e.classList.add("active");
	});

	Pages.showPage(pageId, pageData);

	window.history.replaceState({}, "", `${pageId}${pageData ? `?${encodeURIComponent(pageData)}` : ""}`);
	game.emit("showPage", { page: pageId, data: pageData!, direct: refresh });
}

let saveLock = false;

export function saveNow() {
	try {
		if (saveLock) return;
		const e = Date.now();
		const t = lzwEncode(JSON.stringify(user));
		localStorage.lsver = "2";
		if (t) localStorage.localsave = t;
		const o = Date.now() - e;
		// console.log(`Saving took: ${o}ms`);
		if (o > 1e3) {
			createNotification({
				message:
					"Your save file is large and impacting load times and performance. Consider selling items in your inventory to improve performance.",
			});
		}
	} catch (e) {
		alert(
			"An error occurred doing auto save. Please report it via the discord server! --- " +
				e +
				" - LSL:" +
				(localStorage.localsave?.length || 0) +
				" - GOL:" +
				JSON.stringify(user).length,
		);
	}
}
window.saveNow = saveNow;
window.onbeforeunload = () => saveNow();
function autosave() {
	saveNow();
	setTimeout(autosave, 30 * 1e3);
}
setTimeout(autosave, 30 * 1e3);

export const wipeSave = () => {
	saveLock = true;
	delete localStorage._cbid;
	delete localStorage.localsave;
	delete localStorage.shop;
	delete localStorage.flags;
	delete localStorage.backup;
	delete localStorage.backupid;
	window.location.reload();
};

window.wipeSave = wipeSave;
export const overwriteSave = (data: string) => {
	saveLock = true;
	delete localStorage._cbid;
	delete localStorage.localsave;
	delete localStorage.shop;
	delete localStorage.flags;
	delete localStorage.backup;
	delete localStorage.backupid;
	localStorage.localsave = data;
	// @ts-expect-error
	for (const key of Object.keys(user)) delete user[key];
	Object.assign(user, loadSave());
	addStat("save_times_imported", 1);
	saveLock = false;
	saveNow();

	saveLock = true;
	window.location.reload();
};
window.overwriteSave = overwriteSave;
if (localStorage.backupid && localStorage.backupid !== localStorage._cbid) {
	document.getElementById("recover-btn")!.style.display = "initial";
	document.getElementById("dismiss-recover-btn")!.style.display = "initial";
	document.getElementById("recover-btn")!.onclick = () => {
		if (window.confirm("Do you want to recover your old save? The current save will be lost.")) {
			saveLock = true;
			localStorage._cbid = localStorage.backupid;
			localStorage.localsave = localStorage.backup;
			window.location.reload();
		}
	};
	document.getElementById("dismiss-recover-btn")!.onclick = () => {
		if (window.confirm("Are you sure?")) {
			delete localStorage.backup;
			delete localStorage.backupid;
			localStorage._cbid = localStorage.localuser;
			document.getElementById("recover-btn")!.style.display = "none";
			document.getElementById("dismiss-recover-btn")!.style.display = "none";
		}
	};
} else if (!localStorage.backupid || localStorage.backupid === localStorage._cbid) {
	localStorage.backup = localStorage.localsave;
	localStorage._cbid = Math.random();
	localStorage.backupid = localStorage._cbid;
}

const rankNames = [
	"Recruit",
	"Private I",
	"Private II",
	"Private III",
	"Private IV",
	"Corporal I",
	"Corporal II",
	"Corporal III",
	"Corporal IV",
	"Sergeant I",
	"Sergeant II",
	"Sergeant III",
	"Sergeant IV",
	"Master Sergeant I",
	"Master Sergeant II",
	"Master Sergeant III",
	"Master Sergeant IV",
	"Sergeant Major I",
	"Sergeant Major II",
	"Sergeant Major III",
	"Sergeant Major IV",
	"Lieutenant I",
	"Lieutenant II",
	"Lieutenant III",
	"Lieutenant IV",
	"Captain I",
	"Captain II",
	"Captain III",
	"Captain IV",
	"Major I",
	"Major II",
	"Major III",
	"Major IV",
	"Colonel I",
	"Colonel II",
	"Colonel III",
	"Brigadier General",
	"Major General",
	"Lieutenant General",
	"General",
	"Global General",
] as const;

export function getPlayerLevel(level: number = 0) {
	const k = 0.085;
	const xpNeededForThisLevel = Math.round(level ** (k * level + 1) * 1e3);
	const xpNeededForNextLevel = Math.round((level + 1) ** (k * (level + 1) + 1) * 1e3);
	if (xpNeededForNextLevel <= user.xp && level < 40) {
		return getPlayerLevel(level + 1);
	} else
		return {
			level,
			xps: xpNeededForThisLevel,
			xpa: user.xp - xpNeededForThisLevel, // level progress
			xpp:
				(user.xp - xpNeededForThisLevel) / //level percentage
				(xpNeededForNextLevel - xpNeededForThisLevel),
			xpn: xpNeededForNextLevel - xpNeededForThisLevel,
		};
}
createRoot(() => {
	createEffect(() => {
		const moneyEl = document.getElementById("money")!;
		moneyEl.innerText = numToValuta(user.money, 2);
		moneyEl.dataset.tip = `${(user.money / 100).toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${getCurrency()}`;
		const ticketEl = document.getElementById("tickets")!;
		ticketEl.innerText = numToString(user.tickets);
		const tokenEl = document.getElementById("tokens")!;
		tokenEl.innerText = numToString(user.tokens);
		tokenEl.dataset.tip = user.tokens.toLocaleString("en", { maximumFractionDigits: 0 });
		const levelObj = getPlayerLevel();
		document.getElementById("level-bar-text-left")!.innerText = `${numToString(levelObj.xpa)}/${numToString(levelObj.xpn)} xp`;
		document.getElementById("level-bar-text-right")!.innerText = `level ${levelObj.level}`;
		document.getElementById("level-bar-p")!.style.width = `${levelObj.xpp * 100}%`;
		document.getElementById("level-image")!.style.backgroundImage = `url("images/level ${levelObj.level}.png")`;

		document.getElementById("level-title")!.innerText = user.prestigeTier
			? `${rankNames[levelObj.level]}\nPrestige ${user.prestigeTier}`
			: rankNames[levelObj.level] || "Unknown";
	});
});

export function numToString(num: number, precision = 0) {
	num = Math.floor(num * 10 ** precision) / 10 ** precision;
	switch (true) {
		case num < 1e4:
			return num.toFixed(precision);
		case num < 1e5:
			return `${Math.floor(num / 10) / 100}k`;
		case num < 1e6:
			return `${Math.floor(num / 100) / 10}k`;
		case num < 1e7:
			return `${Math.floor(num / 1e4) / 100}m`;
		case num < 1e9:
			return `${Math.floor(num / 1e5) / 10}m`;
		case num < 1e12:
			return `${Math.floor(num / 1e8) / 10}t`;
		case num < 1e15:
			return `${Math.floor(num / 1e11) / 10}q`;
		default:
			return `${Math.floor(num / 1e12)}q`;
	}
}
export function numToValuta(num: number, precision = 0) {
	switch (localStorage.prefcurrency) {
		case "dollar":
			return `$${numToString(num / 100, precision)}`;
		default:
			return `${numToString(num / 100, precision)}€`;
	}
}
// Close any open dropdowns when clicking anywhere on the document
document.onmousedown = (e) => {
	// Some browsers don't expose `e.path`; use composedPath() as a fallback to get the event propagation path
	const path = e.composedPath() as HTMLElement[];
	// If the click originated inside a dropdown, do nothing so the dropdown can handle the event
	for (let pathIdx = 0; pathIdx < path.length - 2; pathIdx++) if (path[pathIdx]!.classList.contains("dropdown")) return;
	// Hide all visible dropdown elements by removing the "show" class
	for (let i = 0; i < select(".dropdown").length; i++) select(".dropdown")[i]!.classList.remove("show");
	// Remove any dynamically added dropdown DOM nodes that use the "js-dropdown" helper class
	Iterator.from(document.getElementsByClassName("js-dropdown")).forEach((el) => {
		document.body.removeChild(el);
	});
};
export function goToPreviousPage() {
	console.log("Going to previous page");
	if (pageHistory.length > 1) {
		pageHistory.pop();
		showPage(pageHistory.at(-1)!, true, true);
	}
}
const showPageLinks = document.querySelectorAll("[showpage]") as NodeListOf<HTMLElement>;
// manual hydration
for (let i = 0; i < showPageLinks.length; i++) {
	showPageLinks[i]!.onclick = () => showPage(showPageLinks[i]!.getAttribute("showpage") as PageId);
}

window.addEventListener(
	"touchstart",
	(e) => {
		if ((e.target as HTMLElement).tagName !== "BUTTON" && (e.target as HTMLElement).classList.contains("item")) {
			e.preventDefault();
		}
	},
	{ passive: false },
);

window.addEventListener("keydown", (e) => {
	if (e.key === "Escape") goToPreviousPage();
});

// window.addEventListener("resize", () => game.emit("update"));

setInterval(() => {
	user.money += user.upgrades.passiveIncome * user.upgrades.perClick * user.upgrades.perClickMul || 0;
	addStat("earned_passive", user.upgrades.passiveIncome * user.upgrades.perClick * user.upgrades.perClickMul || 0);
	game.emit("update", true);
}, 1e3);

setInterval(() => {
	localStorage.lastSeen = Math.floor(Date.now() / 1e3).toString(36);
}, 1e3);

setInterval(() => {
	if (!user.seasonTimePlayed) user.seasonTimePlayed = 0;
	user.seasonTimePlayed += 1;
	addStat("time_played", 1);
}, 1e3);

function WelcomeBackDialog(secondsOffline: number, possibleEarnedOffline: number) {
	const offlineRevenue = Math.min(possibleEarnedOffline, user.upgrades.offlineRate * user.upgrades.offlineTime);
	const r = document.body.q(".dialog-overlay");
	r.q(".floating-dialog", {
		children: [
			q(".floating-dialog-header", {
				children: [
					q(".floating-dialog-title", "Offline Income"),
					q(".floating-dialog-close", {
						onclick() {
							document.body.removeChild(r);
						},
					}),
				],
			}),
			q(".floating-dialog-body", {
				children: [
					q(
						".floating-dialog-text",
						`Welcome back! You have earned ${(offlineRevenue / 100).toFixed(2)}${getCurrency()} while being offline for ${(secondsOffline / 60 / 60).toFixed(1)} hours!`,
					),
					q(
						".floating-dialog-text",
						offlineRevenue === possibleEarnedOffline
							? ``
							: user.upgrades.offlineTime === 600
								? `This is the maximum amount of money you can earn offline!`
								: `But if your offline income time limit was higher, you could have earned ${(Math.min(possibleEarnedOffline, user.upgrades.offlineRate * 600) / 100).toFixed(2)}${getCurrency()}...`,
					),
				],
			}),
		],
	});
}

interface WelcomeProps {
	secondsOffline: number;
	possibleEarnedOffline: number;
	onClose: () => void;
}

function WelcomeBackDialogSolid(props: WelcomeProps) {
	const offlineRevenue = Math.min(props.possibleEarnedOffline, user.upgrades.offlineRate * user.upgrades.offlineTime);
	const hoursOffline = (props.secondsOffline / 60 / 60).toFixed(1);
	const formattedRevenue = (offlineRevenue / 100).toFixed(2) + getCurrency();

	function handleClose() {
		props.onClose();
	}

	return (
		<div class="dialog-overlay">
			<div class="floating-dialog">
				<div class="floating-dialog-header">
					<div class="floating-dialog-title">Offline Income</div>
					{/** biome-ignore lint/a11y/noStaticElementInteractions: don't feel like fixing css rn **/}
					{/** biome-ignore lint/a11y/useKeyWithClickEvents: shhh */}
					<div class="floating-dialog-close" onClick={handleClose} />
				</div>
				<div class="floating-dialog-body">
					<div class="floating-dialog-text">{`Welcome back! You have earned ${formattedRevenue} while being offline for ${hoursOffline} hours!`}</div>
					<div class="floating-dialog-text">
						{offlineRevenue === props.possibleEarnedOffline
							? ""
							: user.upgrades.offlineTime === 600
								? "This is the maximum amount of money you can earn offline!"
								: `But if your offline income time limit was higher, you could have earned ${(
										Math.min(props.possibleEarnedOffline, user.upgrades.offlineRate * 600) / 100
									).toFixed(2)}${getCurrency()}...`}
					</div>
				</div>
			</div>
		</div>
	);
}

export function mountWelcomeBackDialog(secondsOffline: number, possibleEarnedOffline: number) {
	const container = document.createElement("div");

	const dispose = render(
		() => (
			<WelcomeBackDialogSolid
				onClose={() => {
					dispose();
					document.body.removeChild(container);
				}}
				possibleEarnedOffline={possibleEarnedOffline}
				secondsOffline={secondsOffline}
			/>
		),
		container,
	);

	document.body.appendChild(container);

	return dispose;
}

function calculateOfflineEarnings() {
	const secondsOffline = Math.ceil(Date.now() / 1e3) - parseInt(localStorage.lastSeen, 36);
	const possibleEarnedOffline = Math.floor((user.upgrades.offlineRate * secondsOffline) / 60);
	if (possibleEarnedOffline > 100) {
		mountWelcomeBackDialog(secondsOffline, possibleEarnedOffline);

		user.money += Math.min(possibleEarnedOffline, user.upgrades.offlineRate * user.upgrades.offlineTime);
		addStat("earned_offline", Math.min(possibleEarnedOffline, user.upgrades.offlineRate * user.upgrades.offlineTime));
		game.emit("update");
	}
}
calculateOfflineEarnings();

document.body.classList.add("game-ready");

// hotkeys handler
window.addEventListener("keydown", (e) => {
	if (document.activeElement?.tagName === "INPUT") return;
	if (Pages.currentPage !== "click" && e.key === "e") showPage("click");
	if (Pages.currentPage !== "shop" && e.key === "s") showPage("shop");
	if (Pages.currentPage !== "betting" && e.key === "g") showPage("betting");
	if (Pages.currentPage !== "upgrades" && e.key === "u") showPage("upgrades");
	if (Pages.currentPage !== "missions" && e.key === "m") showPage("missions");
	if (Pages.currentPage !== "achievements" && e.key === "a") showPage("achievements");
	if (Pages.currentPage !== "collection" && e.key === "c") showPage("collection");
	if (Pages.currentPage !== "tradeup" && e.key === "t") showPage("tradeup");
	if (document.activeElement?.tagName === "INPUT") e.preventDefault();
});

function OpenMobileMenu() {
	document.getElementById("menu")!.classList.toggle("mobile-open", true);
}
function CloseMobileMenu() {
	document.getElementById("menu")!.classList.toggle("mobile-open", false);
}
document.getElementById("mobile-nav-button")!.addEventListener("click", OpenMobileMenu);
document.getElementById("pages")!.addEventListener("click", CloseMobileMenu);
game.on("showPage", CloseMobileMenu);
